<template>
  <div v-if="source.kind" class="flex flex-col gap-1">
    <div v-if="source.kind === 'workflow'" class="inline-flex flex-col gap-1 rounded-md border border-emerald-300 bg-emerald-50/60 px-2 py-1.5 max-w-full">
      <div class="flex items-center gap-2 min-w-0">
        <span :class="['rounded px-1.5 py-0.5 font-medium shrink-0', kindTone(source.kind)]">workflow</span>
        <span class="font-medium text-gray-900 truncate sensitive">{{ source.label || (source.id != null ? `#${source.id}` : '') }}</span>
      </div>
      <div v-if="(source.parts || []).length" class="flex flex-wrap gap-1 pl-1">
        <router-link
          v-for="part in source.parts" :key="part.id"
          :to="`/data?tab=DataAttributes&attribute=${part.id}`"
          :class="['rounded px-1.5 py-0.5 font-medium no-underline hover:underline sensitive', kindTone('data_attribute')]"
          :title="`data attribute ${part.id}`"
        >{{ part.label }}</router-link>
      </div>
    </div>
    <div v-else class="flex items-center gap-2 min-w-0">
      <span :class="['rounded px-1.5 py-0.5 font-medium shrink-0', kindTone(source.kind), { italic: generic }]">{{ source.kind }}</span>
      <router-link v-if="to && source.label" :to="to" class="text-primary-600 no-underline hover:underline truncate">{{ source.label }}</router-link>
      <span v-else class="text-gray-900 truncate">{{ source.label || (source.id != null ? `#${source.id}` : '') }}</span>
    </div>
    <div v-if="source.metrics && source.metrics.length > 1" class="text-gray-500 pl-1">{{ source.metrics.length }} metrics: {{ source.metrics.join(', ') }}</div>
    <div v-if="source.via" class="text-gray-400 pl-1">{{ source.via }}</div>
  </div>
  <span v-else class="text-gray-400">&mdash;</span>
</template>

<script>
const STUDIO = {
  metric: 'metrics',
  metric_query: 'metrics',
  metric_alerts: 'metrics',
  metric_insights: 'metrics',
  metric_worklist: 'metrics',
  metric_worklist_columns: 'metrics',
  metric_patients: 'metrics',
  insight: 'metric-insights',
  worklist: 'worklists',
  patient_flag: 'patient-flags',
};
import { GENERIC_KINDS, kindTone } from './sourceKinds';

export default {
  name: 'SourceCell',
  props: { source: { type: Object, required: true } },
  computed: {
    generic() {
      return GENERIC_KINDS.has(this.source.kind);
    },
    to() {
      if (this.source.kind === 'hermes') return this.source.id != null ? `/tenantadmin/hermes/templates/${this.source.id}` : null;
      if (this.source.kind === 'data_attribute') return this.source.id != null ? `/data?tab=DataAttributes&attribute=${this.source.id}` : null;
      const segment = STUDIO[this.source.kind];
      return segment && this.source.id != null ? `/tenantadmin/metric-studio/${segment}/${this.source.id}` : null;
    },
  },
  methods: { kindTone },
};
</script>
